import { defineStore } from 'pinia';

const LOADING_SAFETY_MS = 8000;
let loadingSafetyTimer: ReturnType<typeof setTimeout> | null = null;

export const mainStore = defineStore('mainStore', {
  state: () => ({
    loading: {
      show: false,
      message: '',
      timedOut: false,
    },
    isLogged: false,
    isAlertOpen: false,
    componentKey: 0, // Add the componentKey property with an initial value
  }),

  actions: {
    setLoading(loading: boolean, message='') {
      this.loading.show = loading;
      this.loading.message = message;
      if (loading) this.loading.timedOut = false;
      if (loadingSafetyTimer) {
        clearTimeout(loadingSafetyTimer);
        loadingSafetyTimer = null;
      }
      if (loading) {
        loadingSafetyTimer = setTimeout(() => {
          this.loading.show = false;
          this.loading.message = '';
          this.loading.timedOut = true;
          loadingSafetyTimer = null;
        }, LOADING_SAFETY_MS);
      }
    },

    clearLoadingTimeout() {
      this.loading.timedOut = false;
    },

    // En tu store (mainStore), añade una acción para actualizar la clave del componente
    updateComponentKey() {
      this.componentKey = new Date().getTime(); // Utiliza el timestamp actual como clave
      console.log("Component key updated to", this.componentKey);
    },


    setAlertOpen(isOpen) {
      this.isAlertOpen = isOpen;
      console.log("Alert open status:", this.isAlertOpen);
    }
  }


});